// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1zIQK","bigColWidth":"Table_bigColWidth__1PyxH","biggerColWidth":"Table_biggerColWidth__1_PD0","row":"Table_row__EsGd_","col":"Table_col__3HYg8"};